import styled from 'styled-components';

import Button from '../../../../../components/Button';
import { ReactComponent as CreditCardIcon } from '../../../../../assets/icons/creditCardIcon.svg';
import { ReactComponent as PaypalLogoIcon } from '../../../../../assets/icons/paypalLogo.svg';
import colors from '../../../../../styles/colors';

const StyledOnboardingCard = styled.div`
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 20px;
  width: 100%;
`;

const CreditCard = styled(CreditCardIcon)`
  width: 23px;
  margin-left: 7px;
`;

const StyledCheckoutActionButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  line-height: 1;
  font-size: 13px;
  font-weight: 600;
  height: 36px;
  width: fit-content;
  gap: 5px;
  border: 1px solid ${colors.shades.dark4};
  border-radius: 20px;
  cursor: pointer;

  background-color: ${({ $isDarkTheme, $isSelected }) => {
    if ($isDarkTheme) {
      return $isSelected ? colors.base.alpha : colors.shades.dark1;
    }
    return $isSelected ? colors.shades.dark2 : colors.base.alpha;
  }};

  color: ${({ $isDarkTheme, $isSelected }) => {
    if ($isDarkTheme) {
      return $isSelected ? colors.base.beta : colors.shades.dark4;
    }
    return $isSelected ? colors.base.alpha : colors.shades.dark2;
  }};

  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`;

export {
  StyledOnboardingCard,
  CreditCard,
  PaypalLogoIcon,
  StyledCheckoutActionButton,
  ButtonContainer,
};
